import React from 'react';
import { Table } from 'antd';
import { useIntl } from 'react-intl';

export interface BestsellerOverview {
  id: string;
  name: string;
  sold: number;
  returned: number;
}

interface Props {
  loading?: boolean;
  products?: Array<BestsellerOverview>;
}

const RevenueOverviewBestsellersTable: React.FC<Props> = ({
  loading,
  products,
}) => {
  const intl = useIntl();
  return (
    <Table<BestsellerOverview>
      size="small"
      rowKey="id"
      pagination={false}
      loading={loading}
      dataSource={products}
      css={`
        .ant-table,
        .ant-table-thead > tr > th {
          color: rgba(0, 0, 0, 0.65);
        }
        .ant-table-placeholder {
          height: 189px;
        }
      `}
    >
      <Table.Column<BestsellerOverview>
        key="name"
        title={intl.formatMessage({ defaultMessage: 'Product name' })}
        dataIndex="name"
      />
      <Table.Column<BestsellerOverview>
        key="name"
        title={intl.formatMessage({ defaultMessage: 'Sold' })}
        dataIndex="sold"
        width="10%"
      />
      <Table.Column<BestsellerOverview>
        key="name"
        title={intl.formatMessage({ defaultMessage: 'Returned' })}
        dataIndex="returned"
        width="10%"
      />
    </Table>
  );
};

export default RevenueOverviewBestsellersTable;
